import { TFunction } from "i18next";
import * as yup from "yup";
import { SchemaOf } from "yup";

interface integratorValidationProps {
  PassEnc?: string;
  Username?: string;
}

export const integratorValidationSchema = (
  t: TFunction
): SchemaOf<integratorValidationProps> =>
  yup.object().shape({
    PassEnc: yup
      .string()
      .required(t("password_validation").toString())
      .min(6, t("password_min_valid").toString()),
    Username: yup.string().required(t("user_name_validation").toString()),
  });
